'use strict'

// An agent's display name in the active interface language — core-wl's helper
// (workspace 075f2e7e5, canvas/functions/agentDisplayName.js), in the shared
// base so the chat's @-mention picker (shared/components/_simone) can use it:
// shared cannot import canvas. Registered from shared's functions index (the
// one registered key — canvas no longer registers its own); canvas calls it
// through `_wsShared.functions.agentDisplayName`.
//
// Server-seeded default agents carry their per-language names on
// `metadata.nameI18n` (OrgAgentSeeder — the Personal Assistant is
// { en: 'Personal Assistant', ka: 'პირადი ასისტენტი' }); GET
// /core/users/agents projects that field. A language the record does not
// carry — and every custom agent, which has no nameI18n — falls back to the
// record's own `name`. A blank translation never wins.
export const agentDisplayName = (agent, lang) => {
  if (!agent || typeof agent !== 'object') return ''
  const translated = lang ? agent.metadata?.nameI18n?.[lang] : null
  if (typeof translated === 'string' && translated.trim()) return translated
  return agent.name || ''
}
